export type ProjectPermission =
  | "accessDomain"
  | "editDomain"
  | "accessMail"
  | "accessDatabase"
  | "accessCronjob"
  | "accessSftpSsh"
  | "accessMember"
  | "editMember"
  | "accessCustomer"
  | "accessTariff"
  | "bookHosting"
  | "deleteHosting"
  | "editProject"
  | "accessFileSystem"
  | "accessExtension"
  | "book"
  | "accessConversations"
  | "accessBackup"
  | "accessApp";

export const projectPermissions = {
  accessDomain: ["owner", "emailadmin", "external"],
  editDomain: ["owner", "external"],
  accessMail: ["owner", "emailadmin", "external"],
  accessDatabase: ["owner", "external"],
  accessCronjob: ["owner", "external"],
  accessSftpSsh: ["owner", "external"],
  accessMember: ["owner", "external"],
  editMember: ["owner"],
  accessCustomer: ["inheritedOwner"],
  accessTariff: ["inheritedOwner"],
  bookHosting: ["inheritedOwner"],
  deleteHosting: ["inheritedOwner"],
  editProject: ["owner"],
  accessFileSystem: ["owner", "external"],
  accessExtension: ["owner", "emailadmin", "external"],
  book: ["owner"],
  accessConversations: ["owner", "external"],
  accessBackup: ["owner", "external"],
  accessApp: ["owner", "external"],
};
